import React from 'react'
import Page from '../templates/empower/career-development/spotlight/SpotLight-PACE'

function spotlight() {
  return (
    <div>
      <Page/>
    </div>
  )
}

export default spotlight
